import { render, staticRenderFns } from "./SysDepartRoleModal.vue?vue&type=template&id=673bb194&scoped=true"
import script from "./SysDepartRoleModal.vue?vue&type=script&lang=js"
export * from "./SysDepartRoleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673bb194",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('673bb194')) {
      api.createRecord('673bb194', component.options)
    } else {
      api.reload('673bb194', component.options)
    }
    module.hot.accept("./SysDepartRoleModal.vue?vue&type=template&id=673bb194&scoped=true", function () {
      api.rerender('673bb194', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/SysDepartRoleModal.vue"
export default component.exports